export const NAMESPACE = "PortalHomeTaskCardModel";

export const HOME_TASK_CARD_TABS_INSTANCE_ID = "home-task-card-tabs";

export const TABS = {
  ALL: "all",
  SESSION: "session",
  CONTACT: "contact"
};

export const TAB_IDS = [
  { id: TABS.ALL, title: "All Tasks" },
  { id: TABS.CONTACT, title: "My Tasks" },
  { id: TABS.SESSION, title: "Session" }
];

export const GROUP_BY_IDS = {
  ALL: "all",
  INCOMPLETE: "incomplete",
  DUE_THIS_WEEK: "due_next_7_days"
};

export const GROUP_BY = [
  { id: "all", text: "All", selected: true },
  { id: "incomplete", text: "Incomplete", selected: false },
  { id: "due_next_7_days", text: "Due This Week", selected: false }
];

export const STATUS_CIRCLE_MAPPING = {
  denied: { status: "rejected", size: 30 },
  pending: { status: "pending", size: 30 },
  complete: { status: "approved", size: 30 },
  approved: { status: "approved", size: 30 },
  default: { status: "default", size: 30 }
};

export const MY_SESSION_TASKS_TOOLTIP =
  "Tasks can be completed by any session participant with portal access";

export const MY_ALL_TASKS_TOOLTIP =
  "Tasks specific to my contact or group portal";
